/**
 * CSS Configuration - ES Module wrapper
 * Imports the CJS source of truth and re-exports for ESM consumers (webpack/browser).
 */

// Import from CJS file and re-export
import cjsConfig from './css-config.cjs';
export const { LAZY_LOADED_CSS_SELECTORS, CLASSNAMES_BLACKLIST, CLASSNAMES_FORCE_INCLUDE } = cjsConfig;